import { Nullable } from '@jamesgmarks/utilities';

// TODO: Move these interfaces to hydra/shared package once available

// eslint-disable-next-line no-shadow
enum EInvoiceGenerationType {
  client = 'client',
  group = 'group',
  monthly = 'monthly',
  manual = 'manual'
}

export interface IHydraInvoice {
  id: number;
  freshbooksClientId: number;
  freshbooksInvoiceId: string;
  ownershipGroupId?: Nullable<number>;
  invoiceNumber: string;
  metaData: string;
  hydraState: string;
  freshbooksState: string;
  invoiceDate: string;
  amountInvoiced: string;
  freshbooksOutstandingAmount: Nullable<string>;
  taxes: string;
  currency: string;
  notes: string;
  runId: number;
  taxName: string;
  taxRate: string;
  generationType: EInvoiceGenerationType;
  created: string;
  createdUserId: Nullable<number>;
  modified: Nullable<string>;
  modifiedUserId: Nullable<number>;
}

export interface IHydraInvoiceForOutstandingInvoices extends IHydraInvoice{
  invoiceDueDate:string;
  url:string;
  description:string;
}

// TODO: rename to IHydraInvoice once outstanding invoice view has been removed
export interface IHydraInAppPaymentsInvoice {
  id: number;
  invoiceNumber: string;
  invoiceDate: string;
  amountInvoiced: string;
  taxes: string;
  currency: string;
  ownershipGroupId?: Nullable<number>;
  invoiceDescription: string;
  freshbooksOutstandingAmount: Nullable<string>;
  totalOutstandingAmount?: Nullable<number>;
  paid: Number;
  unpaid: Number;
  overdue: Number;
}

// eslint-disable-next-line no-shadow
export enum EFreshbooksState {
  draft = 'draft',
  viewed = 'viewed',
  paid = 'paid',
  'send-error' = 'send-error'
}

// eslint-disable-next-line no-shadow
export enum EHydraState {
  deleted = 'deleted',
  unsent = 'unsent',
  sent = 'sent',
  'legacy-imported' = 'legacy-imported',
  zeroInvoice = 'zero-invoice',
  unknown = 'unknown',
  sendingEmail = 'sendingEmail',
}
